import logo from "../assets/images/remax-logo_brandlogos.net_za64u-512x512.png";
import headshot from "../assets/images/shutterstock_567772042-min.jpg";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
  faLinkedin,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import avatar1 from "../assets/images/avatar1.png";
import avatar2 from "../assets/images/avatar3.png";
import bannerImg from "../assets/images/House5.jpg";
const constants = {
  AGENT_NAME: "Nick Smithers",
  AGENT_TITLE: "Broker",
  AGENT_NUMBER: "123 456-7890",
  AGENT_EMAIL: "nicksmithers@gmail.com",
  BROKERAGE: "Remax Reality",
  SOCIALS: {
    twitter: "https://www.x.com",
    facebook: "https://www.x.com",
    instagram: "https://www.x.com",
    youtube: "sfsfsf",
    linkedIn: "fssfsf",
    tikTok: "sfsfsf",
  },
  ICONS: {
    twitter: faTwitter,
    facebook: faFacebook,
    instagram: faInstagram,
    youtube: faYoutube,
    linkedIn: faLinkedin,
    tikTok: faTiktok,
  },
  LOGO: logo,
  HEADSHOT: headshot,
  HOME_IMAGE: bannerImg,
  AGENT_ID: process.env.REACT_APP_AGENT_ID,
  OFFICE_ID: process.env.REACT_APP_OFFICE_ID,
  TOKEN: process.env.REACT_APP_TOKEN,
  URL: process.env.REACT_APP_URL,
  
  ENVIRONMENT: process.env.REACT_APP_NODE_ENV,
  DOMAIN: "aptowebsites.com",
  EMAIL_ACCESS_KEY: "",
  ABOUT:
    "With 20 years in the real estate business, I know what it takes to succeed. You can always trust my experience and expertise to help you make the right choice.",
  QUOTE: "Helping you feel at home is my passion",
  TESTIMONIALS: [
    { quote: "Loved working with him!", name: "Larry Ross", image: avatar1 },
    { quote: "Best realtor ever", name: "Sylvia Jones", image: avatar2 },
  ],
};

export default constants;
